import { render, staticRenderFns } from "./TheHomeMain.vue?vue&type=template&id=11cdd460&"
import script from "./TheHomeMain.vue?vue&type=script&lang=js&"
export * from "./TheHomeMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports